import React from 'react';

import 'focus-outline-manager';
import Button from '@material-ui/core/Button';
import { useTranslation, Trans } from 'react-i18next';




export default function CustomHelper({ current, content, totalSteps, gotoStep, close }) {
    const { t } = useTranslation();
    return (
        <main >
            <div className="CustomHelper__content">
                {content}
                <span className="CustomHelper__step_counter">{current + 1} out of {totalSteps}</span>
                {current === totalSteps - 1 ?
                    <Button
                        onClick={() => close()}
                        color="primary"
                        variant="contained"
                        className="CustomHelper__control_button"
                    > {t('doneButton')} </Button>
                    :
                    <Button
                        onClick={() => gotoStep(current + 1)}
                        color="primary"
                        variant="contained"
                        className="CustomHelper__control_button"
                    > {t('nextButton')} </Button>
                }
            </div>
        </main>
    )
}